import React from "react";

import { Divider, Spacer, Container, Row, Col } from "@cleartrip/bento";

import { ReactComponent as FacebookIcon } from "assets/icons/facebook.svg";
import { ReactComponent as TwitterIcon } from "assets/icons/twitter.svg";
import { ReactComponent as LinkedinIcon } from 'assets/icons/linkedin.svg';
import { ReactComponent as InstagramIcon } from 'assets/icons/instagram.svg';
import { ReactComponent as YoutubeIcon } from 'assets/icons/youtube.svg';
import { langTranslate } from 'helper/arabic';

const FlyinFooter = ({ lng = "en" }) => {
  const currentYear = new Date().getFullYear();

  function getDirection() {
    if (lng === "ar") {
      return "rtl";
    } else {
      return "ltr";
    }
  }

  function footerLang(key) {
    if(lng === 'ar') {
      return langTranslate(key)
    } else {
      return key;
    }
  }

  return (
    <footer
      className="footer"
      style={{ direction: getDirection() }}
    >
      <Spacer className="pt-10" />
      <Divider className="bc-neutral-100" />
      <Container>
        <Row>
          <Col className="d-none--xs">
            <Spacer className="pt-4" />
            <div className="flex flex-between flex-top">
              <div className="flex flex-column">
                <ul className="fs-3 flex ls-reset flex-wrap">
                  <li>
                    <a
                      href={`https://www.flyin.com/flyin-rewards.${lng}.html`}
                      title="Flyin Rewards"
                      className="fs-3 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                    >
                      {footerLang("Flyin Rewards")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                  <li className="fs-3">
                    <a
                      className="c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                      title="Flyin Wallet"
                      href={`https://www.flyin.com/flyin-wallet.${lng}.html`}
                    >
                      {footerLang("Flyin Wallet")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                  <li>
                    <a
                      className="c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                      href={`https://www.flyin.com/contactUs.${lng}.html`}
                      title="Contact Us"
                    >
                      {footerLang("Contact Us")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                  <li>
                    <a
                      className="c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                      href={`https://www.flyin.com/franchise/joinUs.${lng}.html`}
                      title="Flyin Franchise"
                    >
                      {footerLang("Flyin Franchise")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                  <li>
                    <a
                      className="c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                      href="https://extranet.flyin.com/#/hotels/suppliers/edit"
                      title="Add Your Property"
                    >
                      {footerLang("Add Your Property")}
                    </a>
                  </li>
                </ul>
                <Spacer className="pt-2" />
                <ul className="flex ls-reset">
                  <li>
                    <span className="fs-2 c-neutral-400">
                      © {currentYear}{" "}
                      <span>
                        {footerLang("Saudi Ebreez Company")}
                      </span>
                    </span>
                  </li>
                  <Spacer className="pr-4" />
                  <li>
                    <a
                      className="fs-2 c-neutral-400 td-none hover:td-underline"
                      href={`https://www.flyin.com/aboutUs.${lng}.html`}
                      title="About Us"
                    >
                      {footerLang("About Us")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                  <li>
                    <a
                      className="fs-2 c-neutral-400 td-none hover:td-underline"
                      href={`https://www.flyin.com/faqs.${lng}.html`}
                      title="FAQ"
                    >
                      {footerLang("FAQ")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                  <li>
                    <a
                      className="fs-2 c-neutral-400 td-none hover:td-underline"
                      href={`https://www.flyin.com/privacyPolicy.${lng}.html`}
                      title="Privacy Policy"
                    >
                      {footerLang("Privacy Policy")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                  <li>
                    <a
                      className="fs-2 c-neutral-400 td-none hover:td-underline"
                      href={`https://www.flyin.com/termsOfUse.${lng}.html`}
                      title="Terms of Use"
                    >
                      {footerLang("Terms of Use")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                  <li>
                    <a
                      className="fs-2 c-neutral-400 td-none hover:td-underline"
                      href={`https://www.flyin.com/howTo.${lng}.html`}
                      title="File a Claim"
                    >
                      {footerLang("File a Claim")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                  <li>
                    <a
                      className="fs-2 c-neutral-400 td-none hover:td-underline"
                      href="https://careers.flyin.com/"
                      title="Careers"
                    >
                      {footerLang("Careers")}
                    </a>
                  </li>
                  <Spacer className="pr-4" />
                </ul>
              </div>
              <div className="flex flex-top">
                <span className="flex flex-middle nmx-1">
                  <span className="fs-2 c-neutral-200 mx-1">
                    {footerLang("Connect")}
                  </span>
                  <a href="https://www.facebook.com/flyin.com" className="h-4">
                    <FacebookIcon
                      height="16px"
                      width="16px"
                      className="mx-1 c-neutral-200"
                    />
                  </a>
                  <a href="https://twitter.com/flyincom" className="h-4">
                    <TwitterIcon
                      height="16px"
                      width="16px"
                      className="mx-1 c-neutral-200"
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/flyin-com"
                    className="h-4"
                  >
                    <LinkedinIcon
                      height="16px"
                      width="16px"
                      className="mx-1 c-neutral-200"
                    />
                  </a>
                  <a href="https://www.instagram.com/flyincom/" className="h-4">
                    <InstagramIcon
                      height="16px"
                      width="16px"
                      className="mx-1 c-neutral-200"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/user/FlyinVideos"
                    className="h-4"
                  >
                    <YoutubeIcon
                      height="16px"
                      width="16px"
                      className="mx-1 c-neutral-200"
                    />
                  </a>
                </span>
              </div>
            </div>
            <Spacer className="pt-4" />
          </Col>
          <Col className="d-block--xs d-none">
            <Spacer className="pt-4" />
            <div className="flex flex-between flex-top">
              <div className="flex flex-column">
                <ul className="fs-2 flex ls-reset flex-wrap">
                  <li className="mb-1">
                    <a
                      href={`https://www.flyin.com/flyin-rewards.${lng}.html`}
                      title="Flyin Rewards"
                      className="fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                    >
                      {footerLang("Flyin Rewards")}
                    </a>
                  </li>
                  <Spacer className="pr-2" />
                  <li className="mb-1">
                    <a
                      className="fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                      title="Flyin Wallet"
                      href={`https://www.flyin.com/flyin-wallet.${lng}.html`}
                    >
                      {footerLang("Flyin Wallet")}
                    </a>
                  </li>
                  <Spacer className="pr-2" />
                  <li className="mb-1">
                    <a
                      className="fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                      href={`https://www.flyin.com/contactUs.${lng}.html`}
                      title="Contact Us"
                    >
                      {footerLang("Contact Us")}
                    </a>
                  </li>
                  <Spacer className="pr-2" />
                  <li className="mb-1">
                    <a
                      className="fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                      href={`https://www.flyin.com/franchise/joinUs.${lng}.html`}
                      title="Blog"
                    >
                      {footerLang("Flyin Franchise")}
                    </a>
                  </li>
                  <Spacer className="pr-2" />
                  <li className="mb-1">
                    <a
                      className="fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline"
                      href="https://extranet.flyin.com/#/hotels/suppliers/edit"
                    >
                      {footerLang("Add Your Property")}
                    </a>
                  </li>
                </ul>
                <div>
                  <span className="fs-1 c-neutral-400">
                    © {currentYear}{" "}
                    <span>
                      {footerLang("Saudi Ebreez Company")}
                    </span>
                  </span>
                </div>
                <div className="flex flex-row flex-wrap">
                  <ul className="flex flex-row ls-reset flex-wrap">
                    <li className="mb-1">
                      <a
                        className="fs-1 c-neutral-400 lh-copy lh-copy--xs td-none hover:td-underline"
                        href={`https://www.flyin.com/aboutUs.${lng}.html`}
                        title="About Us"
                      >
                        {footerLang("About Us")}
                      </a>
                    </li>
                    <Spacer className="pr-2" />
                    <li>
                      <a
                        className="fs-1 c-neutral-400 td-none hover:td-underline"
                        href={`https://www.flyin.com/faqs.${lng}.html`}
                        title="FAQ"
                      >
                        {footerLang("FAQ")}
                      </a>
                    </li>
                    <Spacer className="pr-2" />
                    <li>
                      <a
                        className="fs-1 c-neutral-400 td-none hover:td-underline"
                        href={`https://www.flyin.com/privacyPolicy.${lng}.html`}
                        title="Privacy Policy"
                      >
                        {footerLang("Privacy Policy")}
                      </a>
                    </li>
                    <Spacer className="pr-2" />
                    <li>
                      <a
                        className="fs-1 c-neutral-400 td-none hover:td-underline"
                        href={`https://www.flyin.com/termsOfUse.${lng}.html`}
                        title="Terms of Use"
                      >
                        {footerLang("Privacy Policy")}
                      </a>
                    </li>
                    <Spacer className="pr-2" />
                    <li>
                      <a
                        className="fs-1 c-neutral-400 td-none hover:td-underline"
                        href={`https://www.flyin.com/howTo.${lng}.html`}
                        title="File a Claim"
                      >
                        {footerLang("File a Claim")}
                      </a>
                    </li>
                    <Spacer className="pr-2" />
                    <li>
                      <a
                        className="fs-1 c-neutral-400 td-none hover:td-underline"
                        href="https://careers.flyin.com/"
                        title="Careers"
                      >
                        {footerLang("Careers")}
                      </a>
                    </li>
                    <Spacer className="pr-2" />
                  </ul>
                </div>
                <Spacer className="pt-2" />
                <div className="flex flex-top">
                  <span className="flex flex-middle">
                    <span className="fs-2 c-neutral-200 mr-1">
                      {lng === "ar" ? "الاتصال" : "Connect"}
                    </span>
                    <a href="https://www.facebook.com/flyin.com">
                      <FacebookIcon
                        height="16px"
                        width="16px"
                        className="mx-1 c-neutral-200"
                      />
                    </a>
                    <a href="http://twitter.com/cleartrip">
                      <TwitterIcon
                        height="16px"
                        width="16px"
                        className="mx-1 c-neutral-200"
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/flyin-com"
                    >
                      <LinkedinIcon
                        height="16px"
                        width="16px"
                        className="mx-1 c-neutral-200"
                      />
                    </a>
                    <a
                      href="https://www.instagram.com/flyincom/"
                    >
                      <InstagramIcon
                        height="16px"
                        width="16px"
                        className="mx-1 c-neutral-200"
                      />
                    </a>
                    <a
                      href="https://www.youtube.com/user/FlyinVideos"
                    >
                      <YoutubeIcon
                        height="16px"
                        width="16px"
                        className="mx-1 c-neutral-200"
                      />
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <Spacer className="pt-4" />
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default FlyinFooter;
